<template>
    <ProjectDescriptionText :jsonData="soundDesignData" :basePath="'/soundDesign'" />
</template>

<script>  
    import ProjectDescriptionText from "../components/ProjectDescriptionText.vue"
    import soundDesignData from '@/assets/data/soundDesign.json';

    export default {
        name: 'SoundDesign',
        components: {
            ProjectDescriptionText
        },
        data() {
            return {
                soundDesignData
            }
        }
    }
</script>